import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { LocationSummary } from '../models/location-summary.model';

@Component({
  selector: 'app-location-properties',
  templateUrl: './location-properties.component.html',
  styles: [
  ]
})
export class LocationPropertiesComponent implements OnInit {

  @ViewChild('locationForm') locationForm: NgForm;
  @Input() location: LocationSummary;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
  }

  dismiss(): void {
    this.modal.dismiss();
  }

  submitAttempt: boolean = false;
  save(): void {
    this.submitAttempt = true;
    if (this.locationForm.invalid) {
      return;
    }
    this.ajax.MakeCall('/Entity/SaveLocation', this.location).then(() => {
      this.modal.close();
    }, () => { });
  }
}
